<div id="async-wrapper" class="vh-100" *ngIf="(streamTiles$ | async) as streamTiles">
  <input
    hidden
    type="checkbox"
    name="toggle-panel-checkbox"
    class="toggle-panel-checkbox"
    id="toggle-panel-checkbox"
    [formControl]="panelToggledFormControl"
  />
  <div class="column main-column" id="left" data-test="bottom-container">
    <div class="mobile-fixed">
      <flo-grid-list-view
        #gridRef
        (selectedIdChange)="selectedIdChangeInGridSource.next($event)"
        (selectedElementChange)="selectedElementChangeSource.next($event)"
      >
        <div *floGridListOverlay>
          <header class="video-control-header" data-test="video-control-header">
            <a
              floAnalytics
              routerLink
              title="flosports"
              id="flo-label"
              class="pointer-ok svg-icon-md"
              name="Go To Homepage"
              events="click"
              [analyticsProperties]="eventAnalytics$ | async"
              [floSvg]="liveLogo$ | async"
            >
            </a>
            <flo-multi-cam-widget
              [hidden]="hideMultiCamControls$ | async"
              [streamCount]="activeStreamsLength$ | async"
              [multiCamChange]="cameraConfig$ | async"
              [eventAnalytics]="eventAnalytics$ | async"
              (selectionChanged)="updateCameraConfig($event)"
            >
            </flo-multi-cam-widget>
            <flo-unmute-button
              *ngIf="
                (showMuteButton$ | async) &&
                (currentVolumeState$ | async) as volumeState
              "
              [isMuted]="volumeState.isMuted"
              (click)="
                onUnmuteClick(volumeState)
              "
            >
            </flo-unmute-button>
          </header>
          <flo-video-player-controls
            [hidden]="(showPlayerControls$ | async) === false"
            [volumeStateInput]="volumeState$ | async"
            [videoPlayState]="playerControl$ | async"
            [eventAnalytics]="eventAnalytics$ | async"
            [title]="streamName$ | async"
            [qualityControlState]="qualityControlState$ | async"
            [videoCurrentTime]="videoCurrentTime$ | async"
            [videoBufferAmount]="videoBufferAmount$ | async"
            [isDVR]="isDVRAndHlsSupported$ | async"
            [isLive]="isAtLiveHead$ | async"
            [showLiveBadge]="isLive$ | async"
            [fullScreenElement]="fsRef"
            [typeFormUrl]="typeFormUrl$ | async"
            (clickedPlayToggle)="playToggle($event)"
            (volumeState)="volumeStateSource.next($event)"
            (qualityChanged)="changeVideoQuality($event)"
            (pauseVideoOnSeeking)="pauseVideoOnSeeking($event)"
            (videoPositionChange)="videoPositionChange($event)"
            (clickedSkipForward)="videoSkipForward($event)"
            (clickedSkipBackward)="videoSkipBackward($event)"
            (clickedLiveBadge)="goToLivePlayHeadSource.next($event)"
          >
          </flo-video-player-controls>
        </div>
        <div *floGridListItemNone class="center-grid-item">Select Stream</div>
        <div *floGridListItemNoneDrag [ngStyle]="ngDragStyle"
          >Select Stream</div
        >
        <div *floGridListItemSomeDrag="let row" [ngStyle]="ngDragStyle">{{
          row.value.name
        }}</div>
        <flo-video
          class="center-grid-item"
          data-test="center-grid"
          *floGridListItemSome="let row"
          [autoplay]="true"
          [skipTrackingPreview]="true"
          [isFreeStream]="row.value.isFreeEvent"
          [videoMeta]="row.value.videoPlayerMeta"
          [eventStatus]="realTimeLiveEventStatus$ | async"
          [videoReferenceId]="row.value.id"
          [videoAnalyticsData]="row.value.videoAnalytics"
          [isSelectedVideo]="gridRef.isItemSelected(row.value)"
          [isTbd]="isTbd$ | async"
          [error]="eventStatusError$ | async"
          [qualityLevel]="qualityLevel$ | async"
          [volumeControls]="volumeState$ | async"
          [adVolumeControls]="adVolumeState$ | async"
          [playToggle]="playToggle$ | async"
          [pauseVideoOnSeeking]="pauseVideoOnSeeking$ | async"
          [videoPositionChange]="videoPositionChange$ | async"
          [enableTattoo]="enableTattoo$ | async"
          [videoSkipForward]="videoSkipForward$ | async"
          [videoSkipBackward]="videoSkipBackward$ | async"
          [updateLivePlayHead]="goToLivePlayHead$ | async"
          (hlsLoaded)="setInitialVideoQuality($event)"
          (playState)="setVideoPlayState($event)"
          (videoCurrentTime)="updateVideoTime($event)"
          (videoBufferAmount)="updateVideoBufferAmount($event)"
          (volumeChange)="volumeStateSource.next($event)"
          (adVolumeChange)="adVolumeStateSource.next($event)"
          (prerollAdPlaying)="prerollAdPlayingSource.next($event)"
          (adPlaying)="adPlayingSource.next($event)"
        >
        </flo-video>
      </flo-grid-list-view>
      <h4
        class="title"
        [class.raised]="showMobileShadow"
        data-test="header-title"
        >{{ streamName$ | async }}</h4
      >
    </div>
    <section id="video-context" data-test="stream-container" class="mb-5">
      <ng-template #listRef>
        <flo-grid-list
          data-test="stream-tile-grid-list"
          class="row g-0"
          itemsNgClass="col-md-4 col-xl-3 pt-2"
          [initialFill]="initialFill$ | async"
          [gridRef]="gridRef"
          [items]="streamTiles"
        >
          <ng-container *ngIf="showStreamTile$ | async">
            <flo-stream-tile
              *floGridListItem="let row"
              (tileClick)="row.actions.replace()"
              (tileAddClick)="row.actions.add()"
              (tileRemoveClick)="row.actions.remove()"
              [eventAnalytics]="eventAnalytics$ | async"
              [isPlaying]="row.item.isPlaying"
              [canAdd]="row.item.canAdd"
              [canRemove]="row.item.canRemove"
              [canPlay]="row.item.canPlay"
              [canShowSnapshot]="row.item.canShowSnapshot"
              [streamName]="row.item.name"
              [streamThumbnail]="row.item.streamThumbnailUrl"
              [streamId]="row.item.streamId"
              [sportData]="row.item.sportData$ | async"
              [eventHasSportData]="row.item.eventHasVersusSportData"
            >
            </flo-stream-tile>
          </ng-container>
        </flo-grid-list>
      </ng-template>
      <flo-live-tabs
        (tabSelected)="tabSelected($event)"
        [initialTab]="tabSelected$ | async"
        [eventAnalytics]="eventAnalytics$ | async"
        [showStreamTile]="showStreamTile$ | async"
      >
        <flo-live-tab
          *ngIf="gameCenterInfo$ | async as gameCenterInfo"
          title="game center"
          data-test="game-center-tab"
        >
          <ng-container>
            <flo-html-view [htmlView]="gameCenterInfo"></flo-html-view>
          </ng-container>
        </flo-live-tab>
        <flo-live-tab
          *ngIf="showRaceMonitor$ | async"
          title="live timing"
        >
          <flo-race-monitor [raceMonitorIds]="raceMonitorIds$ | async"></flo-race-monitor>
        </flo-live-tab>
        <flo-live-tab title="streams">
          <ng-template [ngTemplateOutlet]="listRef"></ng-template>
        </flo-live-tab>
        <flo-live-tab title="schedule" *ngIf="eventSchedule$ | async as schedule">
          <div
            class="full-content"
            [innerHtml]="schedule | floSanitizeHtml"
            floDynamicContent
          >
          </div>
        </flo-live-tab>
        <flo-live-tab
          *ngIf="renderReplaysTab$ | async as replayTitle"
          title="replays"
          name="Watch Replay"
        >
          <ng-container *ngIf="replaysTab$ | async as replays">
            <flo-video-grid
              fullScreen="col-md-3"
              [videos]="replays.videos"
              [target]="replays.target"
              [analyticsPropertiesFn]="replays.analyticsPropertiesFn"
              [queryParamsHandling]="replays.queryParamsHandling"
              [queryParamsFn]="replays.queryParamsFn"
            >
            </flo-video-grid>
            <div
              *ngIf="replays.showMoreButton"
              class="row button-container justify-content-center"
            >
              <a
                floAnalytics
                [routerLink]="replays.btnRouterLink"
                target="_blank"
                class="btn btn-primary btn-lg center"
                name="View Replays"
                >View All Videos</a
              >
            </div>
          </ng-container>
        </flo-live-tab>
        <flo-live-tab
          *ngIf="showLiveLike$ | async"
          title="chat"
        >
          <flo-live-like></flo-live-like>
        </flo-live-tab>
      </flo-live-tabs>
    </section>
  </div>
  <div
    class="overlay"
    (click)="collapseOverlay()"
    data-test="right-rail-fab"
  ></div>
  <label for="toggle-panel-checkbox" class="fab">
    <span class="fab-icon"><flo-svg-icon icon="icon-angle-left" width="32px"></flo-svg-icon></span>
  </label>
  <div
    *ngIf="rightRailProps$ | async as rightRail"
    class="column side-column"
    data-test="event-right-rail"
  >
    <section floFetchGeo>
      <header>
        <h5 class="badge-wrap mb-0" data-test="badge">
          <span
            *ngIf="rightRail.isLive"
            class="live-badge ps-0 svg-vertical-align-top"
            aria-hidden="true"
          ><flo-svg-icon width="30px" icon="badge-live"></flo-svg-icon></span>
        </h5>
        <ng-container *ngIf="(isMileSplit$ | async) === false; else mileSplitHeader">
          <a
          class="right-rail-event-title"
          data-test="right-rail-event-title"
          [routerLink]="rightRail?.eventHubLink"
          floAnalytics
          name="Go To Event Hub"
          events="click"
          [analyticsProperties]="eventAnalytics$ | async"
        >
          <h1 class="heading-event-title bold-font">{{ rightRail?.name }}</h1>
        </a>
        </ng-container>
        <ng-template #mileSplitHeader>
          <h1 class="heading-event-title bold-font">{{ rightRail?.name }}</h1>
        </ng-template>

        <ng-container *ngIf="isDVRConcluded$ | async as dvrConcluded">
          <h6 *ngIf="!dvrConcluded">{{ rightRail?.dateRange }}</h6>
          <h6 *ngIf="dvrConcluded">
            {{ dvrConcluded?.startDate | floDate: dvrConcluded?.endDate }}
          </h6>
        </ng-container>
        <flo-live-geo-ip
          *floFetchFillItem="
            let response of rightRail.liveId;
            usingOutputKey: rightRail.liveId
          "
          [title]="response.message"
        ></flo-live-geo-ip>
      </header>
      <h6 *ngIf="isDVRIntermission$ | async as dvrIntermission">
        There's a break in the action. We'll be back at
        {{ dvrIntermission | floLiveDateTime }}</h6
      >
    </section>
    <section
      id="upcoming"
      class="upcoming"
      data-test="upcoming"
    >
    <ng-container *ngIf="!rightRail.onlyShowAds; else justShowAds">
      <div class="today-container" *ngIf="rightRail?.today?.shouldShow">
        <!-- display Today section up to 2 videos -->
        <ng-container *ngTemplateOutlet="videoContent; context: { videoContentItems: rightRail?.today?.items?.slice(0,2), title: rightRail?.today?.title, showThumbnail: true }"></ng-container>
        <!-- display Ad -->
        <ng-container *ngTemplateOutlet="adRectangle"></ng-container>
        <!-- display More Today section if there are any -->
        <ng-container *ngTemplateOutlet="videoContent; context: { videoContentItems: rightRail?.moreToday, title: rightRail?.moreToday ? 'More Today' : null, showThumbnail: true }"></ng-container>
      </div>
      <!-- display Upcoming below -->
      <div class="upcoming-container" *ngIf="rightRail?.today?.shouldShow && rightRail?.upcoming?.shouldShow">
        <ng-container *ngTemplateOutlet="videoContent; context: { videoContentItems: rightRail?.upcoming?.items, title: rightRail?.upcoming?.title }"></ng-container>
      </div>
      <!-- if there is no today videos, split the upcoming videos into "Upcoming" and "More Upcoming" with the ad in between-->
      <div class="upcoming-container" *ngIf="!rightRail?.today?.shouldShow && rightRail?.upcoming?.shouldShow">
        <ng-container *ngTemplateOutlet="videoContent; context: { videoContentItems: rightRail?.upcoming?.items?.slice(0,2), title: rightRail?.upcoming?.title }"></ng-container>
        <!-- display Ad -->
        <ng-container *ngTemplateOutlet="adRectangle"></ng-container>
        <!-- display More Upcoming section -->
        <ng-container *ngTemplateOutlet="videoContent; context: { videoContentItems: rightRail?.moreUpcoming, title: rightRail?.moreUpcoming ? 'More Upcoming' : null }"></ng-container>
      </div>
      </ng-container>
    </section>
    <ng-template #justShowAds>
      <ng-container *ngTemplateOutlet="adRectangle"></ng-container>
    </ng-template>
  </div>
</div>
<flo-lazy
  [componentConstructor]="AdComponent"
  [initialProps]="interstitialAdProps$ | async"
></flo-lazy>
<div class="position-fixed bottom adhesion-ad d-sm-none">
  <flo-lazy
    [componentConstructor]="AdComponent"
    [initialProps]="initialAdhesionProps$ | async"
  ></flo-lazy>
</div>

<ng-template #adRectangle>
  <div class="ad-rectangle d-flex justify-content-center bg-grey-200" data-test="ad-rectangle">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="initialRightRailAdProps$ | async"
      [detectorHeight]="10"
      [detectorWidth]="300"
    ></flo-lazy>
  </div>
</ng-template>

<ng-template #videoContent let-videoContentItems="videoContentItems" let-title="title" let-showThumbnail="showThumbnail">
  <h5 *ngIf="title" class="video-content-title bold-font" data-test="right-rail-section-title">{{ title | uppercase }}</h5>
    <ol floFetchGeo class="video-content-list mb-0">
      <li
        *ngFor="
          let liveEvent of videoContentItems;
          trackBy: trackByTodaysLiveEvents
        "
      >
        <div class="flexed rail-content justify-content-between w-100 pe-3">
          <a
            class="d-flex"
            [routerLink]="liveEvent.routerLink"
            floAnalytics
            tagName="Link"
            name="Switch Live Event"
            events="click"
            [analyticsProperties]="liveEvent.analyticProps"
          >
            <span *ngIf="showThumbnail"
              [ngClass]="{
                'event-image': true,
                'img-wrap': liveEvent.isSelected
              }"
            >
              <div *ngIf="liveEvent.isSelected" class="overlay-3 rounded"></div>
              <img
                class="rounded"
                [src]="liveEvent.thumbnail"
                [class.is-selected]="liveEvent.isSelected"
              />
              <span
                *ngIf="liveEvent.isLive"
                class="badge-status live-icon svg-vertical-align-top"
                aria-hidden="true"
              ><flo-svg-icon icon="badge-live" width="30px"></flo-svg-icon></span>
              <span
                *ngIf="liveEvent.isReplay"
                class="badge-status svg-vertical-align-top"
                floSvg="badge_replay"
                aria-hidden="true"
              ></span>
              <span
                class="playing color-100"
                *ngIf="liveEvent.isSelected && liveEvent.isLive"
              ><flo-svg-icon icon="streaming-bars" width="1.25em"></flo-svg-icon></span>
            </span>
            <div>
              <h4 class="live-event-title small">
                <span>{{ liveEvent.title }}</span>
              </h4>
              <div>
                <time class="flo-footnote">{{ liveEvent.date }}</time>
              </div>
              <flo-live-geo-ip
                *floFetchFillItem="
                  let response of liveEvent.liveId;
                  usingOutputKey: liveEvent.liveId
                "
                [title]="response.message"
              ></flo-live-geo-ip>
            </div>
          </a>
        </div>
      </li>
    </ol>
</ng-template>
